import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push as Push } from 'redux-first-history';
import { useTranslation } from 'react-i18next';

import { PrimaryButton } from '@dev/ee-components';
import { safelyEncodeBase64Url } from '@dev/ee-tools';
import { CampaignType } from '@dev/ee-api/ee-api-models';

import { CampaignsPaths } from '@/services/dictionaries/Paths';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { useCampaignScreensPathsChecker } from '../hooks/useCampaignScreensPathsChecker';

export const ViewReportButton = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { campaign } = useSelector(getCampainCreatorStore);
    const { isDetailsScreen } = useCampaignScreensPathsChecker();

    if (!isDetailsScreen || !campaign) {
        return null;
    }

    const uri = (
        campaign.Type === CampaignType.AbSplit ? CampaignsPaths.CampaignAbResults : CampaignsPaths.CampaignOverview
    )
        .replace(':type', campaign.Type)
        .replace(':name', safelyEncodeBase64Url(campaign.Name));

    return <PrimaryButton text={t('viewreport')} onClick={() => dispatch(Push(uri))} />;
};
